import { Checkbox, Inline, Label, Radio, Stack } from "@adfenix/alexandria";
import { SolidCircleQuestion } from "@adfenix/icons";
import Popover from "components/Popover";
import { useState } from "react";
import { useAgentOffices } from "./getOfficesForAgent";
import { userSelectedHq } from "atoms/auth";
import { useRecoilValue } from "recoil";
import { AgentService } from "@adfenix/types";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";

interface Props {
  agentData: AgentService.AgentModel;
}

export const OfficeSelection = ({ agentData }: Props) => {
  const selectedHq = useRecoilValue(userSelectedHq);
  const { t } = useTranslation();
  const { register } = useFormContext<AgentService.AgentModel>();
  const [seeMoreOffices, setSeeMoreOffices] = useState(false);
  const { agentOffices, otherOfficesOnHq } = useAgentOffices(
    selectedHq?.id,
    agentData
  );
  return (
    <Stack spacing="xs">
      <Inline justifyContent="space-between">
        <Label htmlFor="office-select">{t("agentprofile.primaryoffice")}</Label>

        <Checkbox
          label={t("selfonboarding.officeOverview.filter.all")}
          onChange={() => setSeeMoreOffices(!seeMoreOffices)}
          name="all-offices"
        />

        <Popover trigger={<SolidCircleQuestion />}>
          {t("agentprofile.primaryoffice.description")}
        </Popover>
      </Inline>
      <Stack spacing="xs" style={{ maxHeight: "300px", overflowY: "auto" }}>
        {agentOffices?.map(x => (
          <Radio
            key={x.id}
            {...register("primaryOfficeId")}
            label={x.displayName}
            id={x.id}
            value={x.id}
            disabled={!x.active}
          />
        ))}

        {seeMoreOffices &&
          otherOfficesOnHq?.map(x => (
            <Radio
              key={x.id}
              {...register("primaryOfficeId")}
              label={x.displayName}
              id={x.id}
              value={x.id}
              disabled={!x.active}
            />
          ))}
      </Stack>
    </Stack>
  );
};
